import React, { useEffect, useState } from "react";
import UIBody from "../../../components/ui/UIBody";
import { useParams } from "react-router-dom";
import useApiCallHooks from "../../../hooks/useApiCallHooks"; 
import { Globe, Calendar, BoxArrowUpRight } from "react-bootstrap-icons";

const CaseSectionDetailsPage = () => {
  const { slug } = useParams();
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  const [caseData, setCaseData] = useState(null);

  // Function to remove HTML tags + bullet symbols & extra characters
  const stripHtmlTags = (str) => {
    if (!str) return "";
    return str
      .replace(/<[^>]*>?/gm, "") // remove HTML tags
      .replace(/[•–●▪◦✔✦✧★☆■□→⇒]+/g, "") // remove common bullet/symbols
      .replace(/\s{2,}/g, " ") // clean multiple spaces
      .trim();
  };

  // Fetch API
  useEffect(() => {
    if (slug) {
      callAPI("get", `get-case-study/${slug}`);
    }
  }, [slug]);

  // Store data when API responds
  useEffect(() => {
    if (responce?.data && statusCode === 200) {
      setCaseData(responce.data);
    }
  }, [responce, statusCode]);

  return (
    <UIBody
      loading={loading}
      content={
        caseData && (
          <div
            className="p-4 shadow-lg rounded-4"
          >
            <div className="container">
              <div className="row align-items-center g-4">
                {/* Left Section */}
                <div className="col-lg-12 text-center text-lg-start">
                  <span className="badge bg-light text-dark mb-3 px-3 py-2 rounded-pill">
                    Case Study Spotlight
                  </span>

                  <h2 className="fw-bold display-6">{caseData?.name}</h2>

                  {/* Image */}
                  <div className="my-4">
                    <img
                      src={
                        caseData?.image ||
                        "https://via.placeholder.com/600x400?text=Case+Study"
                      }
                      alt={caseData?.name}
                      className="img-fluid rounded-4 shadow-lg w-100"
                      style={{ maxHeight: "450px", objectFit: "cover" }}
                    />
                  </div>

                  {/* Description (clean text without HTML tags & bullets) */}
                  <p className="text-dark fw-bold mt-3">
                    {stripHtmlTags(caseData?.description)}
                  </p>

                  {/* Meta Info */}
                  <div className="d-flex flex-wrap align-items-center gap-3 mt-4 justify-content-center justify-content-lg-start">
                    <span className="badge bg-secondary">Web Development</span>
                    <div className="text-muted d-flex align-items-center gap-2">
                      <Calendar /> 3 months
                    </div>
                  </div>

                  {/* Tech Stack */}
                  {caseData?.technologies?.length > 0 && (
                    <>
                      <h6 className="mt-4 fw-bold">TECHNOLOGIES USED</h6>
                      <div className="d-flex flex-wrap gap-2 mt-2 justify-content-center justify-content-lg-start">
                        {caseData.technologies.map((tech, i) => (
                          <span
                            key={i}
                            className="badge bg-light text-dark px-3 py-2 rounded-pill"
                          >
                            {tech}
                          </span>
                        ))}
                      </div>
                    </>
                  )}

                  {/* Button */}
                  {caseData?.live_url && (
                    <a
                      href={caseData.live_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-primary d-inline-flex align-items-center gap-2 mt-4 px-4 py-2 rounded-3"
                    >
                      <Globe /> View Live Project <BoxArrowUpRight />
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        )
      }
    />
  );
};

export default CaseSectionDetailsPage;
